import { BehaviorSubject } from "rxjs";
import { createDefer, Deferred } from "applesauce-core/promise";

/** Holds the pending unlock request (deferred resolves with password string) */
export const pinUnlockRequest$ = new BehaviorSubject<Deferred<string> | null>(null);

export function requestPinUnlock(): Promise<string> {
  const defer = createDefer<string>();
  pinUnlockRequest$.next(defer);
  defer.then(() => pinUnlockRequest$.next(null)).catch(() => pinUnlockRequest$.next(null));
  return defer;
}
